import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { PasswordSignIn } from "./PasswordSignIn";
import { CreateDiaryForm } from "./CreateDiaryForm";
import { ForgotPasswordForm } from "./ForgotPasswordForm";

export const openDiary = (mode) => {
  if (typeof mode === "string") window.dispatchEvent(new CustomEvent("diary:mode", { detail: mode }));
  document.getElementById("protect-diary")?.scrollIntoView({ behavior: "smooth", block: "center" });
};

export const ProtectDiary = ({ initialMode = "signin" }) => {
  const navigate = useNavigate();
  const [mode, setMode] = useState(initialMode);
  const [name, setName] = useState("");

  useEffect(() => {
    if (window.location.hash === "#protect-diary") setTimeout(openDiary, 300);
    const onMode = (e) => setMode(e.detail);
    window.addEventListener("diary:mode", onMode);
    return () => window.removeEventListener("diary:mode", onMode);
  }, []);

  const next = new URLSearchParams(window.location.search).get("next");
  const safeNext = next && next.startsWith("/") && !next.startsWith("//") ? next : null;
  const go = (m, uname) => { if (uname !== undefined) setName(uname); setMode(m); };

  return (
    <section id="protect-diary" className="mx-auto max-w-6xl scroll-mt-6 px-4 pb-16 sm:px-6" data-testid="protect-diary-section">
      <div className="mx-auto max-w-md rounded-2xl bg-[#245E63] p-6 shadow-lg sm:p-8">
        {mode === "create" && <CreateDiaryForm onSuccess={() => navigate(safeNext || "/add-memory")} onSignIn={() => go("signin")} />}
        {mode === "signin" && (
          <PasswordSignIn key={`pw-${name}`} defaultUsername={name} onSuccess={() => navigate(safeNext || "/timeline")}
            onForgotPassword={(u) => go("forgotpw", u)} onCreate={() => go("create")} />
        )}
        {mode === "forgotpw" && <ForgotPasswordForm defaultIdentifier={name} onBack={() => go("signin")} />}
      </div>
    </section>
  );
};
